<template>
  <button
    v-if="showButton"
    class="btn btn-outline-primary btn-sm d-flex align-items-center"
    type="button"
    @click="toggleDialer"
  >
    <span class="mr-50">Phone</span>
    <span
      class="erp-phone-dot"
      :class="{
        'erp-phone-dot--ready': isRegistered,
        'erp-phone-dot--busy': hasActiveCall || hasIncomingCall,
        'erp-phone-dot--error': !isRegistered,
      }"
    />
  </button>
</template>

<script>
import { phoneService } from '@/services/phoneService'

export default {
  name: 'PhoneNavbarButton',
  computed: {
    showButton () {
      return this.$store.getters['phone/hasPhoneExtension']
    },
    isRegistered () {
      return this.$store.getters['phone/isRegistered']
    },
    hasActiveCall () {
      return !!this.$store.state.phone.activeCall
    },
    hasIncomingCall () {
      return !!this.$store.state.phone.incomingCall
    },
    dialerVisible () {
      return this.$store.state.phone.dialerVisible
    }
  },
  created () {
    if (localStorage.getItem('accessToken')) {
      phoneService.bootstrap().catch(() => {})
    }
  },
  methods: {
    toggleDialer () {
      this.$store.commit('phone/SET_DIALER_VISIBLE', !this.dialerVisible)
      this.$store.dispatch('phone/persistPreferences')
    }
  }
}
</script>
